<script>
// import VueTrix from 'vue-trix'

export default {
  // components: { VueTrix },
  props: {
    selectedDocument: { type: Object },
    letter: { type: Object }
  },
  computed: {
    localLetter: {
      get() {
        return this.letter;
      },
      set(value) {
        this.$emit('update:letter', value);
      }
    }
  }
}
</script>
<template>
  <v-card-text>
    <v-row>
      <v-col cols="8">
        <v-text-field
          v-model="localLetter.subject"
          outlined
          :label="$t('component.documentValidation.coverSheet.letterMetaDetails.subject.label')"
          @input="$emit('debounced-preview-cover-sheet')"
          @blur="$emit('set-current-date')"
        ></v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="localLetter.date"
          outlined
          :label="$t('component.documentValidation.coverSheet.letterMetaDetails.date.label')"
          @input="$emit('debounced-preview-cover-sheet')"></v-text-field>
      </v-col>
    </v-row>
    <v-textarea
      v-model="localLetter.body"
      clearable
      :rows="12"
      row-height="20"
      counter
      outlined
      required
      class="sender-block-textarea"
      :label="$t('component.documentValidation.coverSheet.letterMetaDetails.text.label')"
      :placeholder="$t('component.documentValidation.coverSheet.letterMetaDetails.placeholder.text')"
      maxlength="1200"
      style="line-height: 17px!important;"
      @input="$emit('debounced-preview-cover-sheet')"
    ></v-textarea>
    <!--    TEXTAREA WILL BE REPLACED BY VUETRIX-->
    <!--    <VueTrix-->
    <!--        v-model="localLetter.body" placeholder="Freitext" style="min-height:400px;"-->
    <!--        @input="$emit('debounced-preview-cover-sheet')"/>-->
  </v-card-text>
</template>
<style>
/* hide the file tools attachment uploader and link button before rendering */
span.trix-button-group.trix-button-group--file-tools,
button.trix-button.trix-button--icon.trix-button--icon-link{
  display: none!important;
}
</style>
